const { combineReducers } = require("@reduxjs/toolkit");


import {reducer as users} from '../data/users'
import {reducer as projects} from '../data/projects'
import {reducer as me} from '../data/me'
import {reducer as news} from '../data/news'
import {reducer as events} from '../data/events'
import {reducer as stuffs} from '../data/stuffs'
import {reducer as categories} from '../data/categories'
import {reducer as status} from '../data/status'
import {reducer as statusEvents} from '../data/status-events'
import {reducer as support} from '../data/support'
import {reducer as awards} from '../data/awards'
import {reducer as gallery} from '../data/gallery'


const rootReducer = combineReducers({
    users,
    projects,
    me,
    news,
    events,
    stuffs,
    categories,
    status,
    support,
    awards,
    gallery,
	statusEvents,
})

export default rootReducer